import { Fragment } from "react";
import { Check, Clock, XCircle } from "lucide-react";

export default function OrderTimeline({ order, trackStatus }) {
  if (order.fulfillment_status === "cancelled") {
    return (
      <div className="flex items-center gap-2 bg-red-50 border border-red-200 rounded-xl px-4 py-3" data-testid="order-timeline-cancelled">
        <XCircle className="h-4 w-4 text-red-500 shrink-0" />
        <p className="text-sm font-semibold text-red-700">
          Order cancelled{order.cancelled_at ? ` on ${new Date(order.cancelled_at).toLocaleDateString()}` : ""}
        </p>
      </div>
    );
  }

  const paid = order.payment_status === "paid";
  const shipped = Boolean(order.shipped_at || order.tracking_number) || ["shipped", "delivered"].includes(order.fulfillment_status);
  const delivered = order.fulfillment_status === "delivered" || trackStatus === "DELIVERED";
  const steps = [
    { label: "Ordered", done: true, date: order.created_at },
    { label: "Paid", done: paid, date: order.paid_at },
    { label: "Shipped", done: shipped, date: order.shipped_at },
    { label: "Delivered", done: delivered, date: null },
  ];

  return (
    <div className="flex items-start w-full pt-1" data-testid="order-timeline">
      {steps.map((s, i) => (
        <Fragment key={s.label}>
          {i > 0 && <div className={`flex-1 h-0.5 mt-3.5 ${s.done ? "bg-brandblue-600" : "bg-slate-200"}`} />}
          <div className="flex flex-col items-center gap-1.5 px-1" data-testid={`order-timeline-step-${s.label.toLowerCase()}`}>
            <div className={`h-7 w-7 rounded-full flex items-center justify-center transition-colors ${s.done ? "bg-brandblue-600 text-white" : "bg-slate-100 text-slate-400 border border-slate-200"}`}>
              {s.done ? <Check className="h-3.5 w-3.5" strokeWidth={3} /> : <Clock className="h-3.5 w-3.5" />}
            </div>
            <p className={`text-[11px] font-semibold ${s.done ? "text-slate-900" : "text-slate-400"}`}>{s.label}</p>
            {s.date && s.done && <p className="text-[10px] text-slate-400 -mt-1">{new Date(s.date).toLocaleDateString()}</p>}
          </div>
        </Fragment>
      ))}
    </div>
  );
}
